export default __webpack_public_path__ + "static/media/trending_down.67cd1d56.svg";